// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newname-diplayer[data-v-6a68e516]{font-size:1.5rem;font-weight:700;margin-top:1rem;padding:.5rem 2rem;border-radius:10.4px;background-color:#eff6ed;gap:10px;font-weight:500;font-size:16px}", ""]);
// Exports
module.exports = exports;
